import Vue from 'vue'
import moment_tz from 'moment-timezone'

const moment = require('moment');
moment.suppressDeprecationWarnings = true;

export default{
    alert(titles, msg, type){
        Vue.prototype.$message ({
            showClose: true,
            message: msg,
            type: type,
            duration:3000
        })
    },
    loadings(n) {
        Vue.prototype.$loading({
            lock: true,
            text: '',
            spinner: 'el-icon-loading',
            background: 'rgba(255, 255, 255, 0.4)',
            target: document.querySelector('body')
        });
        if(n == 2) {
            var loading = Vue.prototype.$loading({});
            loading.close()
        }
    },
    // 格式化时间 时分秒分开（用）
    timestampToTime(timestamp) {
      if (typeof(timestamp) === 'string')
        timestamp = Number(timestamp)
      if (timestamp < 10000000000)
        timestamp = timestamp * 1000 
      let date = new Date(timestamp);
      let Y = date.getFullYear() + ' ';
      let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '/';
      let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + '/';
      //let H =(date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours()) + ':';
      let H =(date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours());
      if(H -12 <=0){ 
          H = H+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) + ' am'; 
      }else if(H-12>0 && H-24<0){ 
          H = (H - 12) < 10?'0'+(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) + ' PM':(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) +' PM'; 
      }else if(H-24 ==0){ 
          H ='00' +':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes())+ ' pm'; 
      }
      // let m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes());
      return H+' '+D+M+Y;
    },
    formatNumber(n) {
      if (n.length === 9) {
        n = '0' + n
      }
      if (n.length === 10) {
        n = n.slice(0, 4) + ' ' + n.slice(4, 7) + ' ' + n.slice(7, 10)
        return n
      } else {
        return n
      }
    },
    getTimeDate(timestamp) {
      if (timestamp < 10000000000)
        timestamp = timestamp * 1000
      let date = new Date(timestamp);
      let Y = date.getFullYear();
      let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1);
      let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
      return Y + '-' + M + '-' + D;
    },
    formateDate(timestamp) {
      let date = new Date(timestamp * 1000);
      let Y = date.getFullYear();
      let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1);
      let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
      return D + '/' + M + '/' + Y;
    },
    formatMonthyear(timestamp) {
      let date = new Date(timestamp * 1000);
      let Y = date.getFullYear();
      let M = date.getMonth()+1
      if (M === 1) {
        M = 'January'
      } else if (M === 2) {
        M = 'February'
      } else if (M === 3) {
        M = 'March'
      } else if (M === 4) {
        M = 'April'
      } else if (M === 5) {
        M = 'May'
      } else if (M === 6) {
        M = 'June'
      } else if (M === 7) {
        M = 'July'
      } else if (M === 8) {
        M = 'August'
      } else if (M === 9) {
        M = 'September'
      } else if (M === 10) {
        M = 'October'
      } else if (M === 11) {
        M = 'November'
      } else if (M === 12) {
        M = 'December'
      }
      return M + ' ' + Y;
    },
    fmoney(num) {  
      if(num && num!=null){  
        num = String(num);  
        var left=num.split('.')[0],right=num.split('.')[1];  
        right = right ? (right.length>=2 ? '.'+right.substr(0,2) : '.'+right+'0') : '.00';  
        var temp = left.split('').reverse().join('').match(/(\d{1,3})/g);  
        return (Number(num)<0?"-":"") + temp.join(',').split('').reverse().join('')+right;  
      }else if(num===0){   //注意===在这里的使用，如果传入的num为0,if中会将其判定为boolean类型，故而要另外做===判断  
          return '0.00';  
      }else{  
          return "";  
      }
    },
    formCard(numb) {
      if (numb.length === 16) {
        return '**** **** **** ' + numb.slice(numb.length - 4, numb.length)
      } else {
        return numb
      }
    },
    getDateFormat(timestamp, format = 'h:mm a') {
      var date = new Date(timestamp)
      date = moment(date).format(format)
      return date
    },
    // 格式化时间 分秒
    timestampToTimeMS(timestamp) {
      let date = new Date(timestamp);
      let H =(date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours());
      if(H -12 <=0){ 
          H = H+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) + ' AM'; 
      }else if(H-12>0 && H-24<0){ 
          H = (H - 12) < 10?'0'+(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) + ' PM':(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) +' PM'; 
      }else if(H-24 ==0){ 
          H ='00' +':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes())+ ' PM'; 
      }
      // let m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes());
      return H;
    },
    // 格式化时间 分秒
    timestampToTimeMS2(timestamp) {
      let date = new Date(timestamp);
      let H =(date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours());
      if(H -12 <=0){ 
          H = H+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()); 
      }else if(H-12>0 && H-24<0){ 
          H = (H - 12) < 10?'0'+(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) :(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()); 
      }else if(H-24 ==0){ 
          H ='00' +':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()); 
      }
      // let m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes());
      return H;
    },
    // 小数截断
    formatDecimal(num, decimal) {
      if (num === null){
        return null
    }
      if (num == 0) {
        return '0.00'
      }
      num = num.toString()
      let index = num.indexOf('.')
      if (index !== -1) {
        num = num.substring(0, decimal + index + 1)
      } else {
        num = num.substring(0)
      }
      return parseFloat(num).toFixed(decimal)
    },
    formatDecimal2 (s, type) {
      if (s== 0) {
        return "0.00";
      }
      if (!s) {
        return null
      }
      if (s == null || s == "") {
        return '';
      }
      if (JSON.stringify(s).indexOf('.') === -1) {
        type = 0
      }
      s = s < 0 && type === 0 ? s.toString().replace(/^(\d*)$/, "$1.") + '.' : s.toString().replace(/^(\d*)$/, "$1.");
      s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
      s = s.replace(".", ",");
      var re = /(\d)(\d{3},)/;
      while (re.test(s))
        s = s.replace(re, "$1,$2");
      s = s.replace(/,(\d\d)$/, ".$1");
      if (type == 0) {// 不带小数位(默认是有小数位)
        var a = s.split(".");
        if (a[1] == "00") {
          s = a[0];
        }
      }
      if (s.indexOf('.') === -1)
        s = s + '.00'
      return s;
    },
    formatDateMonthyear(timestamp) {
      let date = new Date(timestamp * 1000);
      let Y = date.getFullYear();
      let M = date.getMonth()+1
      let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
      if (M === 1) {
        M = 'Jan'
      } else if (M === 2) {
        M = 'Feb'
      } else if (M === 3) {
        M = 'Mar'
      } else if (M === 4) {
        M = 'Apr'
      } else if (M === 5) {
        M = 'May'
      } else if (M === 6) {
        M = 'Jun'
      } else if (M === 7) {
        M = 'Jul'
      } else if (M === 8) {
        M = 'Aug'
      } else if (M === 9) {
        M = 'Sep'
      } else if (M === 10) {
        M = 'Oct'
      } else if (M === 11) {
        M = 'Nov'
      } else if (M === 12) {
        M = 'Dec'
      }
      return D + '-' + M + '-' + Y;
    },
    formatDateMonthyear2(timestamp) {
      let date = new Date(timestamp * 1000);
      let Y = date.getFullYear();
      let M = date.getMonth()+1
      let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
      if (M === 1) {
        M = 'Jan'
      } else if (M === 2) {
        M = 'Feb'
      } else if (M === 3) {
        M = 'Mar'
      } else if (M === 4) {
        M = 'Apr'
      } else if (M === 5) {
        M = 'May'
      } else if (M === 6) {
        M = 'Jun'
      } else if (M === 7) {
        M = 'Jul'
      } else if (M === 8) {
        M = 'Aug'
      } else if (M === 9) {
        M = 'Sep'
      } else if (M === 10) {
        M = 'Oct'
      } else if (M === 11) {
        M = 'Nov'
      } else if (M === 12) {
        M = 'Dec'
      }
      return D + ' ' + M + ' ' + Y;
    },
    formatDateMonthyear3(timestamp) {
      let date = new Date(timestamp * 1000);
      let M = date.getMonth()+1
      let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
      if (M === 1) {
        M = 'Jan'
      } else if (M === 2) {
        M = 'Feb'
      } else if (M === 3) {
        M = 'Mar'
      } else if (M === 4) {
        M = 'Apr'
      } else if (M === 5) {
        M = 'May'
      } else if (M === 6) {
        M = 'Jun'
      } else if (M === 7) {
        M = 'Jul'
      } else if (M === 8) {
        M = 'Aug'
      } else if (M === 9) {
        M = 'Sep'
      } else if (M === 10) {
        M = 'Oct'
      } else if (M === 11) {
        M = 'Nov'
      } else if (M === 12) {
        M = 'Dec'
      }
      return D + '-' + M;
    }
}


// WEBPACK FOOTER //
// ./src/utils/format.js